/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Save_Close_LabelInputs */

const en_automatic_save_close_label = /** @type {(inputs: Automatic_Save_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close Auto Save Modal`)
};

const fr_automatic_save_close_label = /** @type {(inputs: Automatic_Save_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer la fenêtre de sauvegarde automatique`)
};

const de_automatic_save_close_label = /** @type {(inputs: Automatic_Save_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatisches Speichern-Modal schließen`)
};

const it_automatic_save_close_label = /** @type {(inputs: Automatic_Save_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi la finestra modale di salvataggio automatico`)
};

const ru_automatic_save_close_label = /** @type {(inputs: Automatic_Save_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрыть окно автосохранения`)
};

const es_automatic_save_close_label = /** @type {(inputs: Automatic_Save_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar el modo de guardado automático`)
};

const zh_cn2_automatic_save_close_label = /** @type {(inputs: Automatic_Save_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭自动保存模态框`)
};

const ja_automatic_save_close_label = /** @type {(inputs: Automatic_Save_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動保存モーダルを閉じる`)
};

const hi_automatic_save_close_label = /** @type {(inputs: Automatic_Save_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑटो सेव मॉडल बंद करें`)
};

const pt_pt2_automatic_save_close_label = /** @type {(inputs: Automatic_Save_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar Modal de Salvamento Automático`)
};

/**
* | output |
* | --- |
* | "Close Auto Save Modal" |
*
* @param {Automatic_Save_Close_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_save_close_label = /** @type {((inputs?: Automatic_Save_Close_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Save_Close_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_automatic_save_close_label(inputs)
	if (locale === "de") return de_automatic_save_close_label(inputs)
	if (locale === "it") return it_automatic_save_close_label(inputs)
	if (locale === "ru") return ru_automatic_save_close_label(inputs)
	if (locale === "es") return es_automatic_save_close_label(inputs)
	if (locale === "zh-CN") return zh_cn2_automatic_save_close_label(inputs)
	if (locale === "ja") return ja_automatic_save_close_label(inputs)
	if (locale === "hi") return hi_automatic_save_close_label(inputs)
	if (locale === "pt-PT") return pt_pt2_automatic_save_close_label(inputs)
	return en_automatic_save_close_label(inputs)
});